import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import verifyEmailOrPhoneModal from '../../components/VerifyEmailOrPhoneModal/index.vue'
import UserService from '../../services/UserService'
import { showErrorToast, showSuccessToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      emailOrPhone: '',
      modalActive: false
    }
  },
  components: {
    HomeHeader,
    verifyEmailOrPhoneModal
  },
  mounted () {
    // window.analytics.page('loginWithOtp')
    window.analytics.identify('loginWithOtp', {
      path: '/loginWithOtp'
    })
  },
  computed: {},
  methods: {
    uploadModal () {
      this.modalActive = true
      document.body.classList.add('overlayBg')
    },
    close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlayBg')
    },
    async getOtp () {
      if (!this.emailOrPhone || !this.emailOrPhone.length || (!this.validateEmail() && !this.validateNumber())) {
        this.error = 'Invalid email or number passed.'
        showErrorToast(this, this.error)
        return
      }
      if (this.validateEmail() || this.validateNumber()) {
        const resend = false
        const verifyToken = await UserService.verifyEmailOrPhone(this.emailOrPhone, resend)
        if (verifyToken) {
          showSuccessToast(this, 'Otp sent to your mobile')
          this.uploadModal()
        } else {
          this.error = 'Unable to send OTP mobile.'
          showErrorToast(this, this.error)
        }
      }
    },
    validateEmail () {
      return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.emailOrPhone)
    },
    validateNumber () {
      return /^[6-9]\d{9}$/gi.test(this.emailOrPhone)
    }
  }
}
